import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Flex, BadgeVariant, StatusBadge, Text, getChainIconByChainId } from '@mprolab/uikit'
import { observer } from 'mobx-react-lite'
import { ArrowRight } from 'react-feather'
import { useTheme } from 'styled-components'

import { isSupportedChainId } from 'connectors/utils'
import { ProviderActionModalProps } from './index.types'
import { providerActionModalStore } from './ProviderActionModalStore'

const ProviderActionModalContent: React.FunctionComponent<
  Pick<ProviderActionModalProps, 'manual' | 'currentChainId' | 'chainIdToSwitchTo'>
> = observer((props) => {
  const { t } = useTranslation()
  const { manual, currentChainId, chainIdToSwitchTo } = props
  const { chains } = providerActionModalStore
  const theme = useTheme()

  const modalProps = useMemo(() => {
    switch (true) {
      case manual:
        return {
          description: t('walletConnect.manualNetworkChoiceDescription')
        }
      default:
        return {
          description: t('walletConnect.networkSwitchingDescription')
        }
    }
  }, [manual, t])

  const chainIcons = useMemo(() => {
    if (
      !chains.currentChainId ||
      !chains.chainIdToSwitchTo ||
      !isSupportedChainId(chains.currentChainId) ||
      !isSupportedChainId(chains.chainIdToSwitchTo)
    )
      return null
    return (
      <Flex mb="32px">
        <Flex style={{ opacity: 0.5 }}>{getChainIconByChainId(chains.currentChainId, '24px', '24px')}</Flex>
        <Flex m="0px 8px">
          <ArrowRight color={theme.colors.gray6} />
        </Flex>
        {getChainIconByChainId(chains.chainIdToSwitchTo, '24px', '24px')}
      </Flex>
    )
  }, [currentChainId, chainIdToSwitchTo])

  return (
    <Flex fullWidth flexDirection="column">
      <Text mb="16px" color={theme.colors.gray6}>
        {modalProps.description}
      </Text>
      {chainIcons}
      <Flex fullWidth justifyContent="center">
        <StatusBadge title="Please continue in the wallet" variant={BadgeVariant.PENDING} />
      </Flex>
    </Flex>
  )
})

export default ProviderActionModalContent
